/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Caveat_OutflowInputs */

const vi_cashflow_caveat_outflow = /** @type {(inputs: Cashflow_Caveat_OutflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền ra chỉ tính khoản chi đã thanh toán.`)
};

/**

* @param {Cashflow_Caveat_OutflowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_caveat_outflow = /** @type {((inputs?: Cashflow_Caveat_OutflowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Caveat_OutflowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_caveat_outflow(inputs)
});